import { errorToastClassName, successToastClassName, appToast as toast } from "@/components/ui/baseUi/sonner"
import { convertUserToDraft, UserProfileEntity } from "@/modules/users/entities/usersEntity"
import { useUpdateUser } from "@/modules/users/hooks/useUpdateUser"
import { useServicesContext } from "@modules/core/services/services.context"
import { word } from "@modules/core/utils/i18n"
import {
  convertUserProfileFromFormikToUserProfileDraft,
  convertUserToFormik,
  getValidationSchema,
  type UserFormikType,
} from "@modules/profile/myProfile/profileFormikType"
import { useUnit } from "@modules/utils/hooks/useUnit"
import { LoggerType } from "@modules/utils/loggerUtils"
import { useFormik } from "formik"
import { useMemo, useState } from "react"

export const useProfileFormik = (user: UserProfileEntity) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [activeIndex, setActiveIndex] = useState<string>("0")

  const { browserProfileService } = useServicesContext()
  const userDraft = convertUserToDraft(user)
  const { mutateAsync: updateUser } = useUpdateUser()
  const unit = useUnit()

  const validationSchema = useMemo(() => getValidationSchema(activeIndex), [activeIndex])

  const formik = useFormik<UserFormikType>({
    initialValues: convertUserToFormik(userDraft, unit),
    validationSchema,
    onSubmit: async () => {
      try {
        setIsSubmitting(true)
        browserProfileService.setUnit(formik.values.unit)
        await updateUser(convertUserProfileFromFormikToUserProfileDraft(formik.values))
        toast.success(word("profile.page.toast.success"), {
          classNames: successToastClassName(),
        })
      } catch (e: any) {
        console.error(LoggerType.Profile + "update profile", e)
        toast.error(word("global.error.label"), {
          description: e.message,
          classNames: errorToastClassName(),
        })
      } finally {
        setIsSubmitting(false)
      }
    },
  })

  return { formik, isSubmitting, activeIndex, setActiveIndex }
}
